export default __webpack_public_path__ + "static/cert-1-8dbce36f99a09dace4ab32ca98057fde.png";